<!-- --------------------------------------------------------------------------- -->
<!-- Application Layout                                                          -->
<!-- --------------------------------------------------------------------------- -->

<template>
  <div id="app-layout" class="fill-height">
    <nav-drawer class="d-print-none" />
    <!-- Setting ; pointer-events: none; makes click event "go through" to hidden content layer -->
    <div
      class="appBarWrapper"
      :class="appBarColor"
      :style="appBarWrapperStyle"
      style="overscroll-behavior-y: none; height: 68px !important; overflow-y: scroll"
    >
      <app-bar class="d-print-none"></app-bar>
    </div>

    <!-- <div app -->
    <v-main app class="content-area-wrapper ma-0 mx-auto">
      <!-- Animate.css transitions. The name, e.g. fadeInLeft is the name of an animate.css animation-->
      <!-- Not necessary here: <template v-slot:moduleHeader></template> -->
      <!-- <transition :name="transitionName" mode="out-in" enter-active-class="animated fadeIn" leave-active-class=""> -->
      <!-- <transition :name="transitionName" mode="out-in"> -->
      <!-- possible transitions: slide,slideY, ''-->
      <!-- <transition name="fade-in-out" mode="out-in"> -->
      <transition :name="getTransitionName()">
        <router-view id="router-view" class="inherit-height router-view-fixed" :class="routerViewClass" :style="routerStyle"></router-view>
        <v-alert v-if="accessingRestrictedArea" class="px-2 mx-auto restricted-message" dense outlined type="error">
          {{ $t('documents.restricted') }}
        </v-alert>
      </transition>
    </v-main>

    <bottom-nav v-if="!$route.meta.hideFooter" />

    <snackbar style="z-index: 100000 !important" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import configs from '@/common/config';
import AppBar from '@/components/AppBar';
import NavDrawer from '@/components/navdrawer/NavDrawer';

import Snackbar from '@/components/snackbar/Snackbar.vue';
import common from '@/mixins/common';
import { debounce } from '@/common/utils';
import 'animate.css';
import BottomNav from './BottomNav.vue';
import routerStore from '@/router/routerStore';

const TOOLBAR_HEIGHTS = {
  oneRow_xs: 56,
  oneRowHome_xs: 56,
  oneRowHome: 64,
  oneRowHome_sm: 56,
  oneRow_sm: 56,
  twoRows_xs: 56 + 48,
  twoRows_sm: 56 + 48,

  twoRowsHome: 112,
  oneRow: 64,
  twoRows: 112,
};
const DEFAULT_TRANSITION = 'fade';
export default {
  name: 'AppLayout',
  props: {
    source: String,
  },
  mixins: [common],

  components: { BottomNav, NavDrawer, AppBar, Snackbar },
  created() {
    // avoid lots of events by debouncing to 200ms
    window.addEventListener(
      'resize',
      debounce(() => {
        this.$store.commit('onWindowsResize');
      }, 200)
    );
    window.addEventListener('orientationchange', (event) => {
      console.log('on orientationchange ' + event.target.screen.orientation.angle);
      this.$store.commit('onWindowsResize');
    });
    this.$store.commit('onWindowsResize');

    //TODO: necessary? Why?
    this.apiUrl = configs.apiUrl;
    if (this.bottomNavigationPaths.indexOf(this.$route.path) >= 0) {
      this.bottomNav = this.$route.path;
    } else {
      this.bottomNav = void 0;
    }
    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName;

      if (transitionName === 'slide') {
        const toDepth = to.path.split('/').length;
        const fromDepth = from.path.split('/').length;
        transitionName = toDepth < fromDepth ? 'slide-in-right' : 'slide-in-left';
      }

      this.transitionName = transitionName || DEFAULT_TRANSITION;
      next();
    });
  },
  data: () => ({
    navDrawer: true,
    bottomNav: null,

    isBottomNavVisible: true,
    snackbarShow: false,
    timer: null,
    transitionName: DEFAULT_TRANSITION,
    accessingRestrictedArea: false,
  }),

  computed: {
    ...mapState({
      snackbar: (state) => state.snackbar,
      bottomNavigation: (state) => state.configs.bottomNavigation,
      acknowledgeDocument: (state) => state.acknowledgeDocument,
    }),
    appBarWrapperStyle() {
      const toolbarPixelHeight = this.toolbarPixelHeight();
      return { height: toolbarPixelHeight + 'px' };
    },
    routerStyle() {
      const style = {};
      //style.background = this.darkMode ? '#141414' : '#f5f5f5';

      const bottomBarHeight = 54;
      const toolbarPixelHeight = this.toolbarPixelHeight();
      style.top = `${toolbarPixelHeight}px`;
      style.bottom = `${this.$route.meta.hideFooter ? 0 : bottomBarHeight}px`;

      return style;
    },
    appBarColor() {
      if (this.isHomeScreen) {
        return this.theme && this.theme.appBar && this.theme.appBar.home.bg;
      }
      let bg = this.theme && this.theme.appBar && this.theme.appBar.other.bg;
      return bg;
    },

    acknowledgeDocumentTitle() {
      return this.acknowledgeDocument ? this.acknowledgeDocument.title : '';
    },
    isHomeScreen() {
      return this.$route.path === '/';
    },
    bottomNavigationPaths() {
      return this.bottomNavigation.map((item) => item.path);
    },

    routerViewClass() {
      //if (this.xl){
      //  return null
      //}
      return 'scroll-container hide-scrollbar no-overscroll';
    },

    color() {
      return this.isHomeScreen ? this.theme.appBar.home.color : this.theme.appBar.other.color;
    },
  },
  methods: {
    getTransitionName() {
      return routerStore.transitionName;
    },
    toolbarPixelHeight() {
      let propertyAppendix = this.xs ? '_xs' : this.sm ? '_sm' : '';
      let tbHeightProperty = `oneRow${this.isHomeScreen ? 'Home' : ''}${propertyAppendix}`;

      return TOOLBAR_HEIGHTS[tbHeightProperty];
    },
  },

  watch: {
    $route(to, from) {
      if (this.bottomNavigationPaths.indexOf(to.path) >= 0) {
        this.bottomNav = to.path;
      } else {
        this.bottomNav = void 0;
      }
      if (!to.meta.moduleType && !to.params.instance && from.meta.moduleType && to.name != '/' && !this.bottomNavigationPaths.includes(to.name)) {
        this.accessingRestrictedArea = true;
      } else {
        this.accessingRestrictedArea = false;
      }
    },
  },
};
</script>

<style>
.content-area-wrapper {
  width: 100vw;
  height: 100vh !important;
}

.router-view,
.router-view-fixed {
  transition: transform 500ms ease-in-out; /*transform 500ms ease-in-out 0s,*/
  display: block;
  overflow-x: hidden;
  overflow-y: auto;

  position: absolute;
}

.router-view-fixed {
  position: fixed;
  left: 0;
  right: 0;

  overflow-y: hidden;
}

.showHideBtn {
  position: fixed;
  background: repeating-radial-gradient(black, transparent 100px);
  color: white;
  z-index: 10000;
  padding-top: 20px;
  padding-bottom: 20px;
  border-left: 1px solid #404040;
  opacity: 0.5;
  right: 0;
  top: 62vh;
  width: 28px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}

/** Required style for router animation with animate.css */
.page {
  position: fixed;
  width: inherit;
}

.centered {
  margin-right: 0 !important;
}

.restricted-message {
  width: 90%;
}

/** The inner of the router view should always be one pixel higher than the container. This should make the container scroll and avoid pull-to-refresh effect on mobile devices */
#router-view > :first-child {
  height: calc(100% + 1px) !important;
}
</style>
